import { ui } from '@owenscorning/pcb.alpha';

import Product from './Product';
import { wrapRef } from '../../../../../data';

import _ from 'lodash';

const onlyModules = [
  {
    type: 'TabbedContent',
    modules: [
      'Accordion',
      'AlertMessage',
      'AttentionBar',
      'BasicContent',
      'CardSet',
      'ContactUs',
      'ContentAndImage',
      'Figure',
      'FullBleedContent',
      'Gallery',
      'ItemList',
      'MediaObjectSet',
      'Reusable',
      'Table',
    ],
  },
];

const Fleetwood = Product(
  'Product::Fleetwood',
  ui`AttributeSet`({
    query: {
      name: 'Product Attributes',
      path: '/',
    },
  }),
  // Template "sectionDefaults"
  build => [{
    title: 'Contact',
    initial: [
      {
        type: 'Reusable',
        data: {
          reference: wrapRef('Cms::Content', {
            type: 'Reusable',
            path: '',
            name: 'PDP Contact',
          }),
        },
      },
    ],
  }],
  {},
  {
    version: '0.1',
    displayName: 'Fleetwood PDP',
    paths: ['products'],
  },
  [
    {
      title: 'Photo Gallery',
      details: {
        headingAlignment: 'center'
      },
      modules: ['BasicContent', 'Gallery', 'AttentionBar', 'Reusable', 'ContentAndImage'],
      initial: [
        {
          type: 'Gallery',
          data: {
            settings: {
              galleryCarousel: true,
            },
          },
        },
      ],
      showHeading: true,
    },
    {
      title: 'Product Highlights',
      details: {
        headingAlignment: 'center'
      },
      modules: ['ContentAndImage', 'Reusable', 'BasicContent', 'MediaObjectSet', 'Gallery'],
      initial: [
        {
          type: 'TabbedContent',
          data: {
            settings: { tabSize: 'small' },
            tabs: [
              { defaultTab: true, heading: 'Hardware', icon: null },
              { heading: 'Performance', icon: null },
              { heading: 'Design Features', icon: null },
              { heading: 'Minimal Frame', icon: null },
              { heading: 'Homeowner Features', icon: null },
              { heading: 'Construction Benefits', icon: null },
              { heading: 'Warranty & Finishes', icon: null },
            ]
          }
        }
      ],
      opts: { onlyModules },
      showHeading: true,
    },
    {
      title: 'Product Features',
      details: {
        headingAlignment: 'center'
      },
      modules: ['ContentAndImage', 'Reusable', 'BasicContent', 'Table'],
      initial: [
        {
         type: 'Table',
         data: {
          containerSize: { selection: 'm' },
          alignment: 'Center',
         }
        }
      ],
      showHeading: true,
    },
    {
      title: 'Technical Resources',
      details: {
        headingAlignment: 'center'
      },
      modules: ['ContentAndImage', 'Reusable', 'BasicContent', 'TabbedContent'],
      initial: [
        {
          type: 'TabbedContent',
          data: {
            settings: { tabSize: 'small' },
            tabs: [
              { defaultTab: true, heading: 'Architectural Details', icon: null },
              { heading: 'Drawings', icon: null },
              { heading: 'Test Results', icon: null },
              { heading: 'Revit Families (BIM)', icon: null },
              { heading: 'Installation Instructions', icon: null }
            ]
          }
        }
      ],
      opts: { onlyModules },
      showHeading: true,
    },
    {
      title: 'Contact',
      details: {
        headingAlignment: 'center'
      },
      modules: ['ContentAndImage', 'Reusable', 'BasicContent', 'AttentionBar', 'ContactUs'],
      showHeading: true,
      showInSticky: false,
    },
  ],
  "/products",
  // Override Hero
  (build) => ({
    preset: 'custom',
    type: 'tier_6',
  }),
);

export default Fleetwood;
